import React, { useRef } from 'react';
import PropTypes from 'prop-types';

export default function GuessesRemaining({ hintsRemaining }) {
  const initialRef = useRef(hintsRemaining);


  return (
    <div className='item-meta' style={{ marginTop: 10 }}>
      Guesses/Hints Remaining: <b>{initialRef.current}</b>
    </div>
  );
}

GuessesRemaining.propTypes = {
  hintsRemaining: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/components/tack_ai_chat/guesses_remaining.jsx